export type EditorDisplayState = 'EDITOR' | 'SYNCING' | 'PROCESSING_WITH_PROGRESS' | 'PROCESSING' | 'PLACEHOLDER'

export type EditorDisplayStateInputs = {
  isPostProcessingComplete: boolean
  isMinutesGenerationOngoing: boolean
  /** A run rewriting only some agenda items. The rest of the document stays readable and editable throughout. */
  isMinutesGenerationTargeted: boolean
  minutesGenerationProgress: number | null
  editorConstructed: boolean
  hasInitiallySynced: boolean
}

export function deriveEditorDisplayState(inputs: EditorDisplayStateInputs): EditorDisplayState {
  // A targeted run leaves post-processing incomplete while it runs, but covering the document with a loader
  // would defeat the point of it: the agenda items it is rewriting are locked individually instead.
  if (inputs.isPostProcessingComplete || inputs.isMinutesGenerationTargeted) {
    return inputs.editorConstructed && inputs.hasInitiallySynced ? 'EDITOR' : 'SYNCING'
  }
  if (inputs.isMinutesGenerationOngoing) {
    return inputs.minutesGenerationProgress !== null ? 'PROCESSING_WITH_PROGRESS' : 'PROCESSING'
  }
  return 'PLACEHOLDER'
}
